<!--编辑维修订单页面-->
<template>
    <div class="business-content-main">
        <div class="scroll-view">
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title">
                <div>
                    <span>车主信息</span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCarOwner(1)"
                        v-if="!formData.Id"
                    >新增车主</el-button>
                    <!-- <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCarOwner(2)"
                    >编辑车主</el-button> -->
                </div>
            </div>
            <div class="search-ctn">
                <el-form
                    :model="formData"
                    :rules="rules"
                    ref="formData"
                    label-width="90px"
                    style="width: 100%;padding-right:30px;padding-left:30px"
                >
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item
                                    label="选择车主"
                                    prop="UId"
                                >
                                    <el-select
                                        style="width: 100%"
                                        v-model="formData.UId"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchCarOwners"
                                        v-select-scroll-more="searchCarOwnersLoad"
                                        @clear="clearOwners"
                                        @change="carOwnerChange($event)"
                                        @visible-change="carOwnerVisibleChange($event)"
                                        placeholder="选择车主"
                                    >
                                        <el-option
                                            v-for="item in carOwners"
                                            :key="item.Id"
                                            :label="item.Name"
                                            :value="item.Id"
                                            :data-msg="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item
                                    label="联系电话"
                                    prop="PhoneNum"
                                >
                                    <el-input
                                        :disabled="true"
                                        v-model.trim="formData.PhoneNum"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item
                                    label="选择车辆"
                                    prop="CarbarnId"
                                    style="width: 100%"
                                >
                                    <el-select
                                        style="width: 100%"
                                        filterable
                                        clearable
                                        @change="carChange($event)"
                                        v-model="formData.CarbarnId"
                                    >
                                        <el-option
                                            v-for="item in carbarns"
                                            :key="item.CarId"
                                            :label="item.CarDesc"
                                            :value="item.CarId"
                                            :data-msg="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item
                                    label="车牌号码"
                                    prop="CarNum"
                                >
                                    <el-input
                                        :disabled="true"
                                        v-model.trim="formData.CarNum"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item
                                    label="车架号码"
                                    prop="VehicleCode"
                                >
                                    <el-input
                                        :disabled="true"
                                        v-model.trim="formData.VehicleCode"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item
                                    label="发动机号"
                                    prop="EngineNum"
                                >
                                    <el-input
                                        :disabled="true"
                                        v-model.trim="formData.EngineNum"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="section-title">
              <div>检修结果</div>
            </div>
            <div style="height: 200px">
              <el-input type="textarea" placeholder="请输入内容" v-model="formData.Remark" maxlength="500" :rows="8" show-word-limit></el-input>
            </div>
            <div class="section-title">
                <div>维修配件</div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        icon="el-icon-plus"
                        @click="()=>{dialogVisible_AP=true}"
                    >选择配件</el-button>
                </div>
            </div>
            <div  class="pj-list">
                <el-card
                    class="box-card"
                    v-for="(item,index) in formData.AutoPartsList"
                    :key="index"
                    style="margin-bottom: 20px"
                >
                    <div class="pj-item">
                        <i
                            class="el-icon-remove remove-pj"
                            title="删除"
                            @click="removePj(index)"
                        ></i>
                        <div
                            class="image-ctn"
                            v-if="item.Source!=3"
                        >
                            <img
                                :src="item.MainImg ? downloadUrl + item.MainImg+'?imageView2/2/w/200' : ''"
                                alt=""
                                class="pj-cover"
                                :onerror="defaultImg"
                            >
                        </div>
                        <div v-else>
                            <uploadFile
                                :pjIndex="index"
                                :defaultImg="item.MainImg"
                                type="AutoParts"
                                @uploadSuccess="uploadSuccess"
                            ></uploadFile>
                        </div>
                        <div
                            class="pj-input-ctn"
                            v-if="item.Source!=3"
                        >
                            <p>配件名称</p>
                            <el-input
                                type="text"
                                size="small"
                                v-model="item.GoodName"
                                style="width: 200px"
                                disabled
                            ></el-input>
                        </div>
                        <div
                            class="pj-input-ctn"
                            v-else
                        >
                            <p>配件名称</p>
                            <el-input
                                type="text"
                                size="small"
                                v-model="item.GoodName"
                                style="width: 200px"
                            ></el-input>
                        </div>
                        <div class="pj-input-ctn">
                            <p>数量</p>
                            <p>
                                <el-input-number
                                    size="small"
                                    v-model="item.Count"
                                    :min="1"
                                    :max="10"
                                    step-strictly
                                    @input="handlerTotalPrice"
                                ></el-input-number>
                            </p>
                        </div>
                        <div class="pj-input-ctn">
                            <p>配件价格(元)</p>
                            <p>
                                <el-input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    size="small"
                                    v-model="item.ShopPrice"
                                    @input="handlerTotalPrice"
                                ></el-input>
                            </p>
                        </div>
                        <div class="pj-input-ctn">
                            <p>安装费用（元）</p>
                            <p>
                                <el-input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    size="small"
                                    v-model="item.InstallationFee"
                                    @input="handlerTotalPrice"
                                ></el-input>
                            </p>
                        </div>
                        <!-- <div class="pj-input-ctn border-right">
                            <p>优惠金额（元）</p>
                            <p>
                                <el-input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    size="small"
                                    v-model="item.Discount"
                                    @input="handlerTotalPrice"
                                ></el-input>
                            </p>
                        </div> -->
                        <div
                            class="pj-input-ctn"
                            style="width: 150px"
                        >
                            <p>总价（元）</p>
                            <p style="height:32px;line-height:32px;">{{item|handlePrice}}</p>
                        </div>
                    </div>
                </el-card>
                <div class="money-msg">
                  <div>
                    <div class="money-item">
                        <span class="key">配件总价：</span>
                        <span class="value">￥{{OrderAmount}}</span>
                    </div>
                    <!-- <div class="money-item">
                        <span class="key">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠：</span>
                        <span class="value">￥{{DiscountsMoney}}</span>
                    </div> -->
                    <div class="money-item all-money">
                        <span class="key">总价格：</span>
                        <span class="value font-md">￥{{PaymentAmount}}</span>
                    </div>
                   </div>
                </div>
            </div>
            <div class="ops-ctn">
                <el-button
                class="btn-primary"
                size="small"
                @click="submitRepairOrder"
                :disabled="!canRequest"
                >保存</el-button>
                <el-button size="small" @click="back()" style="margin-right:170px;">取消</el-button>
            </div>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="选择配件"
            :before-close="choosePJClose"
            :visible.sync="dialogVisible_AP"
            width="880px"
        >
            <div style="padding-top: 20px">
                <choosePJ
                    @choosePJ="choosePJ"
                    ref="choosePJ"
                ></choosePJ>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :title="carOwnerOperationType * 1 === 1 ? '新增车主' : '编辑车主'"
            :visible.sync="dialogVisible_CarOwner"
            width="1000px"
        >
            <div
                class="dialog-content"
                v-if="dialogVisible_CarOwner"
            >
                <carOwnerEdit
                    ref="customerEdit"
                    obj="owner"
                    :type="carOwnerOperationType"
                    :carOwnerData="carOwnerOperationType === 2 ? carOwnerData : ''"
                    @closeDialog="closeCarOwnerDialog"
                ></carOwnerEdit>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
import choosePJ from "@/components/business/msgSetting/choosePJ";
import uploadFile from "@/components/common/uploadFileGrid.vue";
import carOwnerEdit from "@/components/business/repairMamage/carOwnerEdit";
export default {
  mixins: [mixin],
  name: "editOrder",
  components: {
    breadcrumb,
    choosePJ,
    uploadFile,
    carOwnerEdit
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      pageTitle: "新增维修订单",
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      needConfirm: true,
      canRequest: true,
      dialogVisible_AP: false,
      dialogVisible_CarOwner: false,
      carOwnerOperationType: 1, // 当前对车主的操作：1新增，2编辑
      carOwnerData: "", // 车主数据(编辑时需要传入)
      carOwners: [],
      carbarns: [],
      formData: {
        Id: "",
        EntpId: userMsg.EntpId,
        Operator: userMsg.Account,
        UId: "",
        CarbarnId: "",
        PhoneNum: "",
        CarNum: "",
        VehicleCode: "",
        EngineNum: "",
        Remark: "",
        AutoPartsList: []
      },
      OrderAmount:0,
      DiscountsMoney:0,
      PaymentAmount:0,
      rules: {
        UId: [{ required: true, message: "请选择车主", trigger: "change" }],
        CarbarnId: [
          { required: true, message: "请选择车辆", trigger: "change" }
        ]
      },
      // 用于车主名称列表，分页搜索
      carOwnerForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: '',
      },
    };
  },
   filters: {
    handlePrice(item) {
      let result =(
        item.Count * item.ShopPrice +
        Number(item.InstallationFee) -
        Number(item.Discount)).toFixed(2);
      if (result && result > 0) {
        return result;
      } else {
        return 0;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$util.confirmBeforeLeave(to, from, next, this);
  },
  mounted() {
    this.formData.Id = this.$route.query.oId ? this.$route.query.oId : "";
    if (this.formData.Id) {
      this.pageTitle = "编辑维修订单";
      this.getRepairOrder();
    }
  },
  methods: {
    back() {
      window.history.back(-1);
    },
    uploadSuccess(url, index) {
      this.formData.AutoPartsList[index].MainImg = url + "?imageView2/2/w/200";
    },
    // 处理弹窗关闭
    choosePJClose() {
      this.$refs.choosePJ.clearDataAndClose();
    },
    // 删除配件
    removePj(index) {
      this.formData.AutoPartsList.splice(index, 1);
    },
    // 选PJ
    choosePJ(params) {
      if (!params) {
        this.dialogVisible_AP = false;
        return;
      }
      let target = this.formData.AutoPartsList;
      let addData = params;
      if (!target[0]) {
        this.formData.AutoPartsList = [...addData, ...target];
        if (addData[0].GoodId) {
          this.$refs.choosePJ.clearDataAndClose();
        }
        return;
      }
      if (addData) {
        let needAppend = [];
        for (let i = 0; i < addData.length; i++) {
          // 直接创建的配件
          if (addData[i].GoodId == "") {
            needAppend.push(addData[i]);
            this.formData.AutoPartsList = [...target, ...needAppend];
            return;
          }
          let flag = false;
          for (let j = 0; j < target.length; j++) {
            if (target[j].GoodId == addData[i].GoodId) {
              target[j].Count += 1;
              flag = false;
              break;
            } else {
              flag = true;
            }
          }
          if (flag) {
            needAppend.push(addData[i]);
          }
        }
        this.formData.AutoPartsList = [...target, ...needAppend];
        this.$refs.choosePJ.clearDataAndClose();
      }
      this.dialogVisible_AP = false;
    },

    //新增企业车主
    addCarOwner(type) {
      this.carOwnerOperationType = type;
      this.dialogVisible_CarOwner = true;
    },
    closeCarOwnerDialog(edit) {
      this.dialogVisible_CarOwner = false;
      if (edit) this.getcarOwner();
    },
    carOwnerVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.carOwners.length == 0) that.getcarOwner('');
      }
    },
    carOwnerChange(val) {
      let that = this;
      that.carbarns = [];
      that.formData.CarbarnId = "";
      that.formData.PhoneNum = "";
      that.formData.CarNum = "";
      that.formData.VehicleCode = "";
      that.formData.EngineNum = "";
      if (val) {
        for (const item of that.carOwners) {
          if (item.Id == val) {
            that.formData.UId = val;
            that.formData.PhoneNum = item.PhoneNum;
            that.getCars(val);
            return;
          }
        }
      }
    },
    carChange(val) {
      let that = this;
      that.formData.CarNum = "";
      that.formData.VehicleCode = "";
      that.formData.EngineNum = "";
      if (val) {
        for (const item of that.carbarns) {
          if (item.CarId == val) {
            that.formData.CarNum = item.CarNum;
            that.formData.VehicleCode = item.VehicleCode;
            that.formData.EngineNum = item.EngineNum;
            return;
          }
        }
      }
    },
    searchCarOwners(key) {
      this.getcarOwner(key);
    },
    searchCarOwnersLoad() {
      this.carOwnerForm.Page += 1
      this.searchCarOwners()
    },
    getcarOwner(key, obj) {
      let that = this;
      that.carbarns = [];
      if (![undefined].includes(key)) {
        that.carOwnerForm.Page = 1
        that.carOwnerForm.stopLoad = false
        that.carOwnerForm.key = key
        that.carOwners = []
      }
      if (that.carOwnerForm.stopLoad) return
      this.$util
        .searchCarOwners(
          that.carOwnerForm.key,
          that.carOwnerForm.Page,
          that.carOwnerForm.Limit
        ).then(data => {
          if(!data) return;
          that.carOwnerForm.stopLoad = data.length < that.carOwnerForm.Limit
          that.carOwners = [
            ...that.carOwners,
            ...data
          ]
        })
        .catch(err => {});
    },
    clearOwners() {
      this.carOwners = [];
      this.getcarOwner('');
    },
    getCars(carowerId) {
      let that = this;
      that.carbarns = [];
      that.$util
        .axiosGet({
          url: "/api/CustomerManagement/GetCarOwnerCars",
          data: {
            cId: carowerId,
            entpId: that.formData.EntpId
          },
          hideLoading: true
        })
        .then(res => {
          that.carbarns = res.data;
        });
    },
    handlerTotalPrice(){
        let that = this;
        let apList= [...that.formData.AutoPartsList];
        let _OrderAmount=0;
        let _DiscountsMoney=0;
        let _InstallationFee=0;
        if(!apList||apList.length==0){
            that.OrderAmount=0;
            that.DiscountsMoney=0;
            that.PaymentAmount=0;
        }else{
            for(let i=0;i<apList.length; i++){
              _InstallationFee+=Number(apList[i].InstallationFee);
              _OrderAmount+=Number(apList[i].Count*apList[i].ShopPrice);
              _DiscountsMoney+=Number(apList[i].Discount);
            }
             that.OrderAmount=_OrderAmount.toFixed(2) * 1;
             that.DiscountsMoney=_DiscountsMoney.toFixed(2) * 1;
             that.PaymentAmount=(that.OrderAmount+_InstallationFee).toFixed(2) * 1;
        }
    },
    submitRepairOrder(){
      let that=this;
      let AutoPartsList = that.formData.AutoPartsList;
      if (!AutoPartsList[0]) {
        that.$util.warningMsg("请添加汽配件");
        return;
      }
      for (let i = 0; i < AutoPartsList.length; i++) {
        if (AutoPartsList[i].GoodName == "") {
          that.$util.warningMsg("请输入商品名称！");
          return;
        }
        if (AutoPartsList[i].ShopPrice <= 0 ) {
          AutoPartsList[i].ShopPrice = 0;
          that.$util.warningMsg("配件价格不能小于等于零！");
          return;
        }
        if (AutoPartsList[i].Discount < 0) {
          AutoPartsList[i].Discount = 0;
          that.$util.warningMsg("优惠不能小于零！");
          return;
        }
        if (
          AutoPartsList[i].ShopPrice * AutoPartsList[i].Count +
            AutoPartsList[i].InstallationFee <
          AutoPartsList[i].Discount
        ) {
          that.$util.warningMsg("优惠不能大于配件价格！");
          return;
        }
        if (AutoPartsList[i].InstallationFee < 0) {
          AutoPartsList[i].InstallationFee = 0;
          that.$util.warningMsg("安装费用不能小于零！");
          return;
        }
      }
      that.$refs.formData.validate(valid => {
        if(valid){
            if (!that.canRequest){
                return;
            }
          that.canRequest = false;
          that.$util
            .axiosPost({
              url: "/api/CustomerManagement/EditRepairOrder",
              data: that.formData
            })
            .then(res => {
              if (res.errcode == 0) {
                that.needConfirm = false
                that.$util.successMsg("保存成功");
                setTimeout(() => {
                  that.canRequest = true
                  that.$store.commit("updateNeedRefresh", true);
                  window.history.go(-1);
                }, 2000);
              } else {
                that.canRequest = true
                that.$util.errorMsg(res.errmsg);
              }
            })
            .catch(err => {
              that.canRequest = true
            });                          
        }
      });
    },
    getRepairOrder() {
      let that = this;
      that.$util
        .axiosGet({
          url: "api/CustomerManagement/OrderDetails",
          data: {
            OrderId: that.formData.Id
          }
        })
        .then(res => {
          let data = res.data;
          // that.formData.UId= data.UId;
          that.formData.Remark= data.Remark;
          if(data.CarModel){
             that.carOwners.push({
               Id:data.UId,
               Name:data.CarModel.UName
             });
             that.carbarns.push({
               CarId:data.CarModel.CarId,
               CarDesc: data.CarModel.CarDesc,
               CarNum:data.CarModel.CarNum,
               VehicleCode: data.CarModel.VehicleCode,
               EngineNum: data.CarModel.EngineNum,
             });
             that.formData.CarbarnId= data.CarModel.CarId;
             that.formData.PhoneNum= data.CarModel.PhoneNum;
             that.formData.CarNum= data.CarModel.CarNum;
             that.formData.VehicleCode= data.CarModel.VehicleCode;
             that.formData.EngineNum= data.CarModel.EngineNum;
          }
           that.formData.UId= data.UId;
          let apList=[...data.Goods];
          for (let i = 0; i <apList.length; i++){
              that.formData.AutoPartsList.push({
                MainImg:apList[i].GoodsImg,
                Source:apList[i].Source,
                GoodId:apList[i].GoodsId,
                GoodName:apList[i].GoodsName,
                MarketPrice:0,
                CostPrice:0,
                ShopPrice: apList[i].ShopPrice,
                Discount:apList[i].Discount,
                Count:apList[i].ActualCount,
                InstallationFee: apList[i].InstallationFee
              });
          }

        }).catch(()=>{});
    },
  }
};
</script>
<style lang="less" scoped>
.business-content-main {
  height: 100%;
  overflow: hidden;
}
.scroll-view {
  height: 100%;
  padding-right: 10px;
  overflow-y: scroll;
}
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 20px;
  margin-bottom: 20px;
}
.quill-editor {
  height: 200px;
}
.pj-cover {
  width: 90px;
  height: 80px;
}
.pj-item {
  display: flex;
  position: relative;
  padding: 10px;
  .jj {
    display: flex;
    align-items: center;
    width: 150px;
    line-height: 1.2em;
    flex-grow: 1;
  }
}
.remove-pj {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  font-size: 25px;
  color: @font3Color;
  cursor: pointer;
}
.pj-input-ctn {
  padding: 0 5px;
  text-align: center;
  flex-grow: 1;
  input {
    padding-right: 0;
    width: 100px;
    line-height: 24px;
    border-radius: 5px;
    border: 1px solid @border1Color;
  }
  p:nth-child(1){
      line-height:40px
  } 
}
.border-right {
  border-right: 1px solid @border1Color;
}
.pj-list {
  padding-bottom: 20px;
}
.money-msg {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
.money-item {
  width: 182px;
  display: flex;
  justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
  .key {
    flex-shrink: 0;
  }
}
.all-money {
  color: red;
}
.ops-ctn {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 150px;
  z-index: 1;
}
</style>
<style lang="less">
.pj-input-ctn {
  input {
    padding-right: 0;
  }
}
.uploadFile {
  .el-upload--picture-card {
    width: 92px;
    height: 82px;
    line-height: 82px;
    margin-right: 10px;
  }
}
</style>